import { AppHelper } from "../../appHelper.js"
import { CommonApp, CommonAppProps, Context, Entity, Metadata } from "./commonApp.js";
import { Helper } from "../util/helper.js";
import { IndividualDataHelper } from "../util/individualDataHelper.js";
import { NotificationHelper } from "../util/notificationHelper.js";
import { HTTPService, JsonResultClass } from "../util/httpManager.js";
import React from "react";

export class IndividualNDataEdit extends React.Component<IndividualNDataEditProps, any>{
    common = new AppHelper();
    private _indivHelper = IndividualDataHelper.create();

    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    save = (closeAfterSave) => {
        if (this.common.validate()) {
            // Entweder der PK der View oder aber die übergebene ID für die Tabelle verwenden (für DynamicGrid)
            this.props.entity[this.props.keys.id1Name] = Helper.hasValue(this.props.tableNameId)
                ? this.props.tableNameId : this.props.mainContext.keyVal1;
            const toSend = { data: JSON.stringify(this._indivHelper.convertToIndividualItem(this.props.entity, this.props.fieldsMetadata)), id1: Helper.hasValue(this.props.tableNameId) ? this.props.tableNameId : this.props.mainContext.keyVal1 };
            if (Helper.hasValue(this.props.entity[this.props.keys.id2Name])) {
                toSend["id2"] = this.props.entity[this.props.keys.id2Name];
            }
            if (Helper.hasValue(this.props.tableName)) {
                toSend["tableName"] = this.props.tableName;
            }

            let methodName: string = this.props.entity.IsNew ? 'Add' : 'Save';
            if (this.props.type == 'Dynamic')
                methodName += 'Dynamic';

            HTTPService.post<JsonResultClass>(this.props.type + 'IndividualN/' + methodName + '/?asJson=true', toSend)
                .then(result => {
                    if (result.Code === 0) {
                        this.props.entity.IsNew = false;
                        for (let i = 0; i < result.Data.length; i++) {
                            if (result.Data[i].Identifier === this.props.keys.id1Name) {
                                this.props.entity[this.props.keys.id1Name] = result.Data[i].Value;
                            } else if (result.Data[i].Identifier === this.props.keys.id2Name) {
                                this.props.entity[this.props.keys.id2Name] = result.Data[i].Value;
                            }
                        }

                        NotificationHelper.showSuccessMessage(this.props.translations["Standard.Msg.SpeichernErfolgreich"]);
                    } else {
                        NotificationHelper.showErrorMessage(this.props.translations["Standard.Msg.SpeichernFehler"]);
                    }
                    this.common.handlePostSave(result.Code === 0, closeAfterSave);
                });
        }
    }

    componentDidMount() {
        if (this.props.hasDefaults) {
            this.common.setEntityDirtyState(true);
        }
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
};

export interface IndividualNDataEditProps extends CommonAppProps {
    type: string;
    tableName?: string,
    tableNameId?: any,
    keys: {
        id1Name: string;
        id2Name: string;
    };
    fieldsMetadata: Array<any>;
    hasDefaults: boolean;
    entity: Entity;
    mainContext?: Context;
    //context?: {
    //    contextType?: string
    //};
    translations?: any;
    metadata: Metadata;
    isWindow: boolean;
}